module.exports = require('./assignIn');



//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201706012359-95877d6b9a-master/~/lodash/extend.js
// module id = 1076
// module chunks = 1